/* unplugin-vue-components disabled */import script from "./about.vue?vue&type=script&setup=true&lang=js"
export * from "./about.vue?vue&type=script&setup=true&lang=js"

import "./about.vue?vue&type=style&index=0&id=2cd0a18b&scoped=true&lang=scss"

import exportComponent from "/Users/admin/Desktop/project/klb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cd0a18b"]])

export default __exports__